import { Comunidad } from "./comunidad";

export class ComunidadPublicacion{
    constructor(
        public readonly Id: number,
        public readonly ImagenPortadaUrl: string | null,
        public readonly ComunidadId: number,
        public readonly ComunidadNombre: string | null,
        public readonly Titulo: string | null,
        public readonly Descripcion: string | null,
        public readonly Activo: boolean,
        public readonly FechaCreacion: Date,
        public Adjuntos: ComunidadPublicacionAdjunto[]
    ){}
}

export class UploadComunidadPublicacionAdjuntoResponseDto{
    constructor(
        public readonly Archivos: ComunidadPublicacionAdjunto[]
    ){}
}

export class ComunidadPublicacionAdjunto {
    constructor(
        public readonly Id: number,
        public readonly ComunidadPublicacionId: number,
        public readonly UrlDocumento: string | null,
        public readonly NombreDocumento: string | null,
        public IncluidoEnCuerpoMensaje: boolean
    ){}
}

export class SearchComunidadPublicacionRequestDto{
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,

        public readonly VerSoloActivos: boolean,
        public readonly Activo: boolean,
        public readonly ComunidadId: number | null,
        public readonly ComunidadNombre: string | null,
        public readonly Comunidad: Comunidad | null,
        public readonly FechaDesde: number | null,
        public readonly FechaHasta: number | null,
    ){}
}

export class SearchComunidadPublicacionResponseDto{
    constructor(
        public readonly count: number,
        public readonly result: SearchComunidadPublicacionItemDto[]
    ){}
}

export class SearchComunidadPublicacionItemDto{
    constructor(
        public readonly Id: number,
        public readonly ImagenPortadaUrl: string | null,
        public readonly Titulo: string | null,
        public Activo: boolean
    ){}
}

export class SaveComunidadPublicacion{
    constructor(
        public readonly Id:number,
        public readonly ImagenPortadaUrl: string | null,
        public readonly ImagenPortadaBase64: string | null,
        public readonly ImagenPortadaExtension: string | null,
        public readonly ComunidadId: number,
        public readonly Titulo: string | null,
        public readonly Descripcion: string | null,
        public readonly Activo: boolean,
        public readonly NotificarUsuarios: boolean,
        public Adjuntos: ComunidadPublicacionAdjunto[]
    ){}
}

export class DashboardComunidadPublicacionRequestDto{
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly VerSoloActivos: boolean,
        public readonly Activo: boolean,
        public readonly ComunidadId: number,
        public readonly ConsorcioId: number,
    ){}
}

export class DashboardComunidadPublicacionResponseDto{
    constructor(
        public readonly count: number,
        public readonly result: DashboardComunidadPublicacionItemDto[]
    ){}
}

export class DashboardComunidadPublicacionItemDto{
    constructor(
        public readonly Id: number,
        public readonly ComunidadId: number,
        public readonly ComunidadNombre: string | null,
        public readonly ImagenPortadaUrl: string | null,
        public readonly Titulo: string | null,
        public readonly Descripcion: string | null,
        public readonly FechaCreacion: Date
    ){}
}
